import React from "react";

const Header = () => {
  return (
    <div className="header">
      <h1>Budget App</h1>
    </div>
  );
};

export default Header;
